import { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { User } from 'api/models';
import { UserProfileInfo } from 'api/user';
import { getCurrentUserProfileState } from 'data/current-user-profile';
import { getUserById } from 'utils/idb-utils';

export const useUser = (): UserProfileInfo => {
  const context = useSelector(getCurrentUserProfileState);

  if (!context.data) {
    throw new Error('User Profile is not loaded');
  }

  return context.data;
};

export const useUserById = (userId: number) => {
  const [user, setUser] = useState<User | null>(null);

  const fetchUser = useCallback(async () => {
    const userInfo = (await getUserById(userId)) as User;

    setUser(userInfo);
  }, [userId]);

  useEffect(() => {
    fetchUser();
  }, [fetchUser]);

  return user;
};

// To be used only when anonymous user check is needed
export const useIsUserAnonymousSafe = () => {
  const context = useSelector(getCurrentUserProfileState);

  if (!context.data) {
    return true;
  }

  return false;
};
